// API related actions
export const LOAD_ORIGINS_REQUEST = '@@toyota/LOAD_ORIGINS_REQUEST';
export const LOAD_ORIGINS_SUCCESS = '@@toyota/LOAD_ORIGINS_SUCCESS';
export const LOAD_ORIGINS_FAILED = '@@toyota/LOAD_ORIGINS_FAILED';
export const SUBMIT_NEW_ORIGIN_REQUEST = '@@toyota/SUBMIT_NEW_ORIGIN_REQUEST';
export const SUBMIT_NEW_ORIGIN_SUCCESS = '@@toyota/SUBMIT_NEW_ORIGIN_SUCCESS';
export const SUBMIT_NEW_ORIGIN_FAILED = '@@toyota/SUBMIT_NEW_ORIGIN_FAILED';
export const SUBMIT_EDIT_ORIGIN_REQUEST = '@@toyota/SUBMIT_EDIT_ORIGIN_REQUEST';
export const SUBMIT_EDIT_ORIGIN_SUCCESS = '@@toyota/SUBMIT_EDIT_ORIGIN_SUCCESS';
export const SUBMIT_EDIT_ORIGIN_FAILED = '@@toyota/SUBMIT_EDIT_ORIGIN_FAILED';
// complementary actions
export const CHANGE_ORIGIN_TEXT_FILTER = '@@toyota/CHANGE_ORIGIN_TEXT_FILTER';
export const FILTER_ORIGINS = '@@toyota/FILTER_ORIGINS';
export const INITIALIZE_ORIGIN_DATA = '@@toyota/INITIALIZE_ORIGIN_DATA';
